import React from 'react';
import TermBody from './TermsBody'
import { Helmet } from 'react-helmet'
import * as SG from '../../../constants/AppSettings'

export default class Component extends React.Component {
 render = () => {
   const metaInfo = (
     <Helmet>
       <title>利用規約 | {SG.META_TITLE}</title>
       <meta name='description' content='サークルー(circrew)の利用規約ページです。サークルーをご利用いただく上での利用の流れやルールなどを記載しています。' />
     </Helmet>
   )

   return (
     <section className='terms container'>
      {metaInfo}
      <h2 className='headline'>利用規約</h2>
      <TermBody />
     </section>
   )
 }
}


// WEBPACK FOOTER //
// ./src/components/StaticPages/Terms/Terms.jsx